import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';

const color = "white";

const RetroUpdateInfo = styled('div')({
    color: `${color}`,
    textAlign: 'center',
    fontSize: '1rem',
    marginTop: '20px',
});

const LocalTimeDisplay = () => {
    const [localTime, setLocalTime] = useState(dayjs().format('DD MMM YYYY HH:mm:ss'));

    useEffect(() => {
        const interval = setInterval(() => {
            setLocalTime(dayjs().format('DD MMM YYYY HH:mm:ss'));
        }, 1000); // Update every second
    
        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    return (
        <RetroUpdateInfo>
            Local time: {localTime}
        </RetroUpdateInfo>
    );
};

export default React.memo(LocalTimeDisplay);
